export default "/asset/hmd_sim.32fa7457.png";